<template>
  <Text variant="body-small">
    <span>By proceeding, you agree to the&nbsp;</span>
    <Link class="terms-link" color="accent" :to="termsAndConditionsLink" target="_blank">Terms & Conditions</Link>
    <span>&nbsp;and&nbsp;</span>
    <Link class="terms-link" color="accent" :to="privacyAndPolicyLink" target="_blank">Privacy Policy</Link>
  </Text>
</template>

<script setup lang="ts">
import { Link, Text } from '@tallo/design-system';
import { privacyAndPolicyLink, termsAndConditionsLink } from '@tallo/navigation';
</script>

<style lang="scss" scoped>
.terms-link {
  font-weight: var(--t-font-weight-medium);
}
</style>
